export function getCountdownParts(target, now = Date.now()) {
  const targetTime = Date.parse(target);
  const remaining =
    Number.isFinite(targetTime) && Number.isFinite(now) ? Math.max(0, targetTime - now) : 0;
  const totalSeconds = Math.floor(remaining / 1000);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor(totalSeconds / 3600) % 24,
    minutes: Math.floor(totalSeconds / 60) % 60,
    seconds: totalSeconds % 60,
  };
}

function mountCountdown(element) {
  const render = () => {
    const parts = getCountdownParts(element.dataset.target);

    for (const [unit, value] of Object.entries(parts)) {
      element
        .querySelector('[data-countdown-' + unit + ']')
        ?.replaceChildren(String(value).padStart(2, '0'));
    }
  };

  render();
  window.setInterval(render, 1000);
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-lowkey-countdown]').forEach(mountCountdown);
}
